/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SubscriptionPriceOption
 */
export interface SubscriptionPriceOption {
    /**
     *
     * @type {string}
     * @memberof SubscriptionPriceOption
     */
    priceId?: string;
    /**
     *
     * @type {string}
     * @memberof SubscriptionPriceOption
     */
    name?: string;
    /**
     *
     * @type {string}
     * @memberof SubscriptionPriceOption
     */
    interval?: SubscriptionPriceOptionIntervalEnum;
    /**
     *
     * @type {number}
     * @memberof SubscriptionPriceOption
     */
    amount?: number;
    /**
     *
     * @type {string}
     * @memberof SubscriptionPriceOption
     */
    currencyCode?: string;
    /**
     *
     * @type {boolean}
     * @memberof SubscriptionPriceOption
     */
    isDefault?: boolean;
    /**
     *
     * @type {Date}
     * @memberof SubscriptionPriceOption
     */
    createdAt?: Date;
}

/**
 * @export
 */
export const SubscriptionPriceOptionIntervalEnum = {
    Unknown: "Unknown",
    Day: "Day",
    Week: "Week",
    Month: "Month",
    Year: "Year",
} as const;
export type SubscriptionPriceOptionIntervalEnum =
    (typeof SubscriptionPriceOptionIntervalEnum)[keyof typeof SubscriptionPriceOptionIntervalEnum];

/**
 * Check if a given object implements the SubscriptionPriceOption interface.
 */
export function instanceOfSubscriptionPriceOption(
    value: object,
): value is SubscriptionPriceOption {
    return true;
}

export function SubscriptionPriceOptionFromJSON(
    json: any,
): SubscriptionPriceOption {
    return SubscriptionPriceOptionFromJSONTyped(json, false);
}

export function SubscriptionPriceOptionFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): SubscriptionPriceOption {
    if (json == null) {
        return json;
    }
    return {
        priceId: json["priceId"] == null ? undefined : json["priceId"],
        name: json["name"] == null ? undefined : json["name"],
        interval: json["interval"] == null ? undefined : json["interval"],
        amount: json["amount"] == null ? undefined : json["amount"],
        currencyCode:
            json["currencyCode"] == null ? undefined : json["currencyCode"],
        isDefault: json["isDefault"] == null ? undefined : json["isDefault"],
        createdAt:
            json["createdAt"] == null ? undefined : new Date(json["createdAt"]),
    };
}

export function SubscriptionPriceOptionToJSON(
    value?: SubscriptionPriceOption | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        priceId: value["priceId"],
        name: value["name"],
        interval: value["interval"],
        amount: value["amount"],
        currencyCode: value["currencyCode"],
        isDefault: value["isDefault"],
        createdAt:
            value["createdAt"] == null
                ? undefined
                : value["createdAt"].toISOString(),
    };
}
